import { render, staticRenderFns } from "./rewardHall.vue?vue&type=template&id=859cbba0&scoped=true&"
import script from "./rewardHall.vue?vue&type=script&lang=js&"
export * from "./rewardHall.vue?vue&type=script&lang=js&"
import style0 from "./rewardHall.vue?vue&type=style&index=0&id=859cbba0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859cbba0",
  null
  
)

export default component.exports